export default "__VITE_ASSET__hjcfUb8a__"